import { RootState } from '../../../store';

export const getCurrentUserPermissions = (state: RootState) => state.user.currentUserPermissions;
export const getUsers = (state: RootState) => state.user.users;
export const getAvailableResources = (state: RootState) => state.user.availableResources;
export const getCurrentUser = (state: RootState) => state.user.currentUser;
